import { render, staticRenderFns } from "./DecisionLabelInputs.vue?vue&type=template&id=3cdb758c&"
import script from "./DecisionLabelInputs.vue?vue&type=script&lang=ts&"
export * from "./DecisionLabelInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports